<template lang="pug">
  .log-field.d-flex.flex-column.align-end
    v-textarea(
      v-model="log"
      auto-grow
      dark
      flat
      full-width
      placeholder="Type your text here…"
      rows="2"
      :loading="loading"
      @keydown="sendOnHotkey"
    ).log-field__text
    v-btn(
      color="primary"
      @click="sendLog"
      :disabled="loading || !log"
      data-test="custom-log-btn"
    ).btn-common.btn-commmon_bold.log-field__btn.px-6
      | Send
      v-icon(right) mdi-arrow-right
</template>

<script>
import Svc from "../../core/candidates-service";
import ErrMixin from "@/mixins/errors.mixin"
import { isMac } from '../../../../../../util';

export default {
  props: {
    ID: {
      type: Number,
      required: true
    }
  },

  mixins: [ErrMixin],

  data: () => ({
    log: '',
    loading: false,
    svc: null
  }),

  created() {
    this.init()
  },

  mounted() {
  },

  methods: {
    init() {
      this.svc = new Svc();
    },

    async sendLog() {
      try {
        this.loading = true;
        await this.svc.addCustomLog(this.ID, this.log);
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      } finally {
        this.loading = false;
        this.log = '';
      }
    },

    sendOnHotkey(e) {
      if(!this.log || this.loading) return
      if (e.ctrlKey && e.code === "Enter") {
        this.sendLog()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .log-field {
    padding: 10px 14px 14px 14px;
    background-color: $log-secondary;

    &__btn {
      margin-top: 4px;
    }

    &__text {
      width: 100%;
      &::v-deep {
        .v-input__slot {
          &::after, &::before {
            display: none;
          }
        }
        textarea {
          color: $log-default;
          font-size: 14px;
          font-weight: 500;
          &::placeholder {
            color: $log-default;
            font-size: 14px;
            font-weight: 500!important;
          }
        }
      }
    }
  }
</style>
